import React from 'react'
import {
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    RedditShareButton,
    RedditIcon,
    EmailShareButton,
    EmailIcon,
} from 'react-share';
export default class SocialShare extends React.Component {
    render(){
	var url = "https://sharemeals.org";
	var iconSize = 40;
	var description = "This awesome organization uses technology, advocacy, and education to end college hunger!";
	return (
	    <div style={{paddingTop: '5px'}}>
		<FacebookShareButton
		    url={url}
		    hashtag="#sharemeals">
		    <FacebookIcon size={iconSize} />
		</FacebookShareButton>
		<LinkedinShareButton
		    title="Share Meals"
		    description={description}
		    url={url}>
		    <LinkedinIcon size={iconSize} />
		</LinkedinShareButton>
		<TwitterShareButton
		    title={description}
		    via="sharemeals"
		    url={url}>
		    <TwitterIcon size={iconSize} />
		</TwitterShareButton>
		<RedditShareButton
		    title={description}
		    url={url}>
		    <RedditIcon size={iconSize} />
		</RedditShareButton>
		<EmailShareButton
		    subject="Share Meals: Ending College Hunger"
		    body={description + "\n\n" + url}
		    url={url}>
		    <EmailIcon size={iconSize} />
		</EmailShareButton>
	    </div>
	);
    }
}



// WEBPACK FOOTER //
// ./src/components/social-share.jsx